import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaxtrackService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
  requestOptions: Object = {
    headers: this.headers,
    responseType: 'text',
    withCredentials: true,
  };

  public translate(packet: string): Observable<String[]> {
    return this.http.post<String[]>(
      `${this.apiServerUrl}/maxtrack/translate`,
      packet,
      this.requestOptions
    );
  }

  public status(serial: string[]): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/maxtrack/statusmxt`,
      { serial },
      this.requestOptions
    );
  }
  public profileFilesName(): Observable<any> {
    return this.http.get<any>(`${this.apiServerUrl}/maxtrack/profileFilesName`);
  }

  public diffConfig(fileId: any, packet: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/maxtrack/diffConfig/${fileId}`,
      packet
    );
  }
  public translateProfileFile(fileId: any, fileType: String): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/maxtrack/translateProfileFile`,
      { fileId: fileId, fileType: fileType },
      { withCredentials: true }
    );
  }
}
